// extracted by mini-css-extract-plugin
export default {"table":"Table_table__YUzYe","Cell__Highlight":"Table_Cell__Highlight__gTu-+"};